module.exports = __webpack_public_path__ + "static/clients_gallery_expiring@2x-2ce760924acda4bb779bdd660f8b1176.png";